// TSS vite/03 §"Query keys".

export const genealogyKeys = {
    all:  ['genealogy'],
    tree: (animalId, depth) => ['genealogy', 'tree', animalId, depth],
};
